var map = {
	"./add-icon.png": 4801,
	"./almulla-loader.png": 5558,
	"./almulla-logo.svg": 7360,
	"./call-icon-default.svg": 4660,
	"./call-icon.svg": 76,
	"./default-loader.gif": 9898,
	"./done-icon.png": 8480,
	"./inprogress-icon.png": 7072,
	"./logo.png": 3153,
	"./logo.svg": 3935,
	"./marker.png": 8554,
	"./tick-icon.png": 6433,
	"./ultimate-loader.svg": 4453,
	"./user-img.png": 9355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;